export const TriggerListCardSkeleton: React.FC = () => (
  <div className='animate-pulse flex flex-col items-between justify-center gap-[15px] text-left bg-surface border border-skeleton-border px-4 py-4 rounded-[35px] overflow-hidden relative'>
    <div className='absolute top-0 right-0 flex items-center justify-end gap-[5px] px-4 py-2 bg-skeleton rounded-bl-[15px]'>
      <div className='bg-skeleton-hi h-[15px] w-[60px] rounded-lg' />
      <div className='relative'>
        <div className='absolute top-[1px] left-[1px] w-[13px] h-[13px] rounded-[10px] bg-skeleton-hi' />
        <div className='w-[15px] h-[15px] rounded-[10px]' />
      </div>
    </div>
    <div className='bg-skeleton-hi h-[20px] w-[40%] rounded-lg mt-[5px]' />

    <div className='flex items-end justify-between bg-skeleton pl-5 pr-4 py-4 rounded-[35px]'>
      <div className='grid sm:grid-cols-2 gap-[10px] grow'>
        <div className='mb-[10px]'>
          <div className='h-[12px] w-[20%] bg-skeleton rounded-lg mb-[8px]' />
          <div className='h-[17px] w-[50%] bg-skeleton rounded-lg' />
        </div>
        <div className='mb-[10px]'>
          <div className='h-[12px] w-[20%] bg-skeleton rounded-lg mb-[8px]' />
          <div className='h-[17px] w-[50%] bg-skeleton rounded-lg' />
        </div>
        <div className='col-span-2'>
          <div className='mb-[10px]'>
            <div className='h-[12px] w-[20%] bg-skeleton rounded-lg mb-[8px]' />
            <div className='h-[17px] w-[70%] bg-skeleton rounded-lg' />
          </div>
        </div>
      </div>
      <div className='bg-skeleton-hi w-[50px] h-[50px] rounded-[25px]' />
    </div>
  </div>
)
